import React from "react"
import ToolTip from "react-portal-tooltip"
import strings from "../../localization/strings"
import FontIcon from "material-ui/FontIcon"
import { green500, red500 } from "material-ui/styles/colors"
import moment from "moment"
import { IDate } from "../../models"

interface IProps {
    keyStr: string
    exported: boolean
    exportNote: string
    exportedDate: IDate
    exportedBy: string
}
interface IState {
    open: boolean
}

export default class PayrollByHierarchyEmployeeRowExportedColumn extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            open: false
        }
    }

    render() {
        return (
            <div>
                <ToolTip active={this.state.open} position="bottom" arrow="center" parent={`#export-${this.props.keyStr}`}>
                    <div
                        style={{
                            paddingLeft: 15,
                            paddingRight: 15,
                            textAlign: "center"
                        }}
                    >
                        <span style={{ fontWeight: 600 }}>{this.props.exported ? strings.Exported : strings.Failed_Export}</span>
                        <br />
                        {this.props.exportNote && [
                            <span style={{ fontWeight: 600 }} key="export note">{this.props.exportNote}</span>,
                            <br key="new line" />
                        ]}
                        <span>{`${moment(this.props.exportedDate).format("hh:mma MM/DD/YYYY")}`}</span>
                        <br />
                        <span>{`${this.props.exportedBy}`}</span>
                    </div>
                </ToolTip>
                <div style={{ marginTop: -5, fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    <FontIcon
                        id={`export-${this.props.keyStr}`}
                        className={`fa fa-${this.props.exported ? "check" : "close"}`}
                        style={{ fontSize: 20 }}
                        color={this.props.exported ? green500 : red500}
                        onMouseOver={() => this.setState({ open: true })}
                        onMouseOut={() => this.setState({ open: false })}
                    />
                </div>
            </div>
        )
    }
}
